import * as React from "react";
import { observer } from "mobx-react";
import { InputNumber } from "../Shared";

export interface IInputNumberComponentProps {
	model: InputNumber;
	locale: string;
	onChange?: () => void;
	testId?: string;
}

@observer
export class InputNumberComponent extends React.Component<IInputNumberComponentProps, {}> {

	handleChange = (event: React.FormEvent<any>) => {
		let valueString = ((event.target as any).value as string).replace(/,/g, '').replace(/\D/g, '');
		let value = Number(valueString);
		this.props.model.value = isNaN(value) ? this.props.model.value : value;
		if (this.props.onChange) {
			this.props.onChange();
		}
	}

	render() {
		let label = this.props.model.label;

		return <label>
			{label ? <span>{label}</span> : null}
			<input type="text"
				value={this.props.model.value ? this.props.model.value.toLocaleString(this.props.locale) : ""}
				onChange={this.handleChange}
				disabled={this.props.model.isReadOnly}
				className={!this.props.model.isValid ? "is--input-invalid" : null}
				placeholder={this.props.model.placeHolder}
				data-test-id={this.props.testId} />
			{this.props.model.validationMessage ? <span>{this.props.model.validationMessage}</span> : null}
		</label>;
	}
}

